<header>
    <div class="dropdown">
      <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <li>
          <a class="dropdown-item" href="#">Action</a>
        </li>
        <li>
          <a class="dropdown-item" href="#">Another action</a>
        </li>
        <li>
          <a class="dropdown-item" href="#">Something else here</a>
        </li>
      </ul>
    </div>
    <nav class="bg-white">
        <div class="container-fluid m-0 py-lg-1">
            <div class="navbar navbar-expand-lg bg-white max-w-1185 pb-0 pt-3 py-md-2 mx-auto px-lg-3">
                <div class="pb-2 pe-2 ms-2 ms-md-0">
                    <a class="navbar-brand" href="https://www.selec.com/home">
                        <img src="assets/seleclogo.png" alt="Selec Logo" class="nav-logo max-w-87" width="123" height="62">
                    </a>
                </div>
                <button class="navbar-toggler shadow-none rounded-3 p-1 p-md-2 me-2 me-md-0 " type="button"
                    data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown"
                    aria-expanded="false" aria-label="Toggle navigation">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                        fill="#ffffff">
                        <path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z" /></svg>
                </button>
                <div class="collapse navbar-collapse ms-lg-5 " id="navbarNavDropdown">
                    <ul class="navbar-nav font-11 ms-lg-2 gap-lg-1">
                        <li class="nav-item">
                            <a class="nav-link text-uppercase fw-bold text-black rounded-2 ease-in-out3 px-2 mt-1 mt-lg-0"
                                aria-current="page" href="https://www.selec.com/home">Home</a>
                        </li>
                        <li class="nav-item border-top dropdown">
                            <a class="nav-link text-uppercase fw-bold text-black ease-in-out3 rounded-2 dropdown-toggle px-2 mt-1 mt-lg-0"
                                href="#" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                About
                            </a>
                            <div class="dropdown-menu mt-0 p-0 pt-lg-4">
                                <div class="sub-menu mt-1 rounded-2">
                                    <ul
                                        class="list-unstyled border-bottom-0 border-end-0 border-start-0 mt-0 mx-1 p-lg-1">
                                        <li><a class="dropdown-item font-13 text-black ease-in-out3 px-1 py-2"
                                                href="https://www.selec.com/about">Overview</a>
                                        </li>
                                        <li>
                                            <hr class="dropdown-divider bg-gray m-0 m-0">
                                        </li>
                                        <li><a class="dropdown-item font-13 text-black ease-in-out3 px-1 py-2"
                                                href="https://www.selec.com/about/milestones">Milestones</a>
                                        </li>
                                        <li>
                                            <hr class="dropdown-divider bg-gray m-0">
                                        </li>
                                        <li><a class="dropdown-last dropdown-item font-13 text-black ease-in-out3 px-1 py-2"
                                                href="https://www.selec.com/about/global-network">Global network</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                        <li class="nav-item border-top dropdown">
                            <a class="nav-link text-uppercase fw-bold text-black ease-in-out3 rounded-2 dropdown-toggle px-2 mt-1 mt-lg-0"
                                href="#" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                Download
                            </a>
                            <div class="dropdown-menu mt-0 p-0 pt-lg-4">
                                <div class="sub-menu mt-1 rounded-2">
                                    <ul
                                        class="list-unstyled border-bottom-0 border-end-0 border-start-0 mt-0 mx-1 p-lg-1">
                                        <li><a class="dropdown-item font-13 text-black ease-in-out3 px-1 py-2"
                                                href="https://www.selec.com/datasheet">Download Center</a>
                                        </li>
                                        <li>
                                            <hr class="dropdown-divider bg-gray m-0 m-0">
                                        </li>
                                        <li><a class="dropdown-item font-13 text-black ease-in-out3 px-1 py-2"
                                                href="https://www.selec.com/catalog">Catalog & Brochures</a>
                                        </li>
                                        <li>
                                            <hr class="dropdown-divider bg-gray m-0">
                                        </li>
                                        <li><a class="dropdown-last dropdown-item font-13 text-black ease-in-out3 px-1 py-2"
                                                href="https://www.selec.com/software">Software</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                        <li class="nav-item border-top dropdown">
                            <a class="nav-link text-uppercase fw-bold text-black ease-in-out3 rounded-2 active dropdown-toggle px-2 mt-1 mt-lg-0"
                                href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                Careers
                            </a>
                            <div class="dropdown-menu mt-0 p-0 pt-lg-4">
                                <div class="sub-menu mt-1 rounded-2">
                                    <ul
                                        class="list-unstyled border-bottom-0 border-end-0 border-start-0 mt-0 mx-1 p-lg-1">
                                        <li><a class="dropdown-item font-13 text-black ease-in-out3 px-1 py-2"
                                                href=".">Careers at Selec</a>
                                        </li>
                                        <li>
                                            <hr class="dropdown-divider bg-gray m-0 m-0">
                                        </li>
                                        <li><a class="dropdown-item font-13 text-black ease-in-out3 px-1 py-2"
                                            [routerLink]="['/jobslist']">Current Openings</a>
                                        </li>
                                        <li>
                                            <hr class="dropdown-divider bg-gray m-0">
                                        </li>
                                        <li><a class="dropdown-last dropdown-item font-13 text-black ease-in-out3 px-1 py-2"
                                                href="https://careers.selec.com/candidate/">Candidate login</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                        <li class="nav-item border-top">
                            <a class="nav-link text-uppercase fw-bold text-black ease-in-out3 rounded-2 px-2 mt-1 mt-lg-0"
                                href="https://www.selec.com/contact">Contact
                                us</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </nav>
</header>